import { BasicAction, LibraryTraceCrumb, ThirdPartyLibrary, ThirdPartyLibraryState, ThirdPartyLibraryTile } from "../types/ThirdPartyLibrary";
import { ACTIONS } from "./actions";

const Default: ThirdPartyLibraryState = {
    libraries: {}
}

export const thirdPartyLibrary = (state: ThirdPartyLibraryState = Default, action: BasicAction): ThirdPartyLibraryState => {
    let updatedState = state;

    switch (action.type) {
        case ACTIONS.SET_SCREEN_TYPE:
            updatedState = {
                ...state,
                screenType: action.payload.screenType
            }
            break;
        case ACTIONS.OPEN_FOR_SELECTION:
            updatedState = {
                ...state,
                openForSelection: true,
                ...action.payload && {
                    rootCategory: {
                    id:action.payload.categoryId,
                    categoryName:action.payload.categoryName,
                    isPatternContainer:action.payload.patternContainer,
                    isOpenToUse:true,
                    }
                },
            }
            break;
        case ACTIONS.CLEAR_ROOT_ID:
            updatedState = {
                ...state,
                rootCategory:{
                    ...state.rootCategory,
                    isOpenToUse:false,
                }as any
            }
            break;
        case ACTIONS.CLOSE_VIEW:
            updatedState = {
                ...state,
                openForSelection: false,
                ...action.payload
            }
            break;
        case ACTIONS.IMAGE_CONSUMED:
            updatedState = {
                ...state,
                rootCategory: {
                    ...state.rootCategory,
                    isConsumed: true,
                } as any
            }
            break;
        case ACTIONS.CLEAR_NAV_TILES: {
            const source = state.source
            if (source) {
            updatedState = {
                ...state,
                    libraries: {
                        ...state.libraries,
                        [source]: {
                            ...state.libraries[source],
                trace: []
            }
                    }
                }
            }
            break;
        }
        case ACTIONS.SET_LIBRARY_SOURCE: {
            const source = action.payload
            const sourceTilesAvailable = state.libraries[source]?.tiles
            if (sourceTilesAvailable && sourceTilesAvailable.length) {
                updatedState = {
                    ...state, source, libraries: {
                        ...state.libraries,
                        [source]: {
                            ...state.libraries[source],
                            selectionGrid: [...sourceTilesAvailable],
                        }
                    }
                }
            } else
                updatedState = {
                    ...state, source,
                    libraries:{
                        ...state.libraries,
                        [source]:{
                            ...state.libraries[source],
                            trace:[]
                        }
                    }
                }
        }
            break;
        case ACTIONS.UPDATE_PROGRESS_STATE:
            const { source, progress } = action.payload
            updatedState = {
                ...state, libraries: {
                    ...state.libraries,
                    [source]: { ...state.libraries[source], progressState:progress }
                }
            }
            break;
        case ACTIONS.SETUP_LIBRARY: {
            const { source, tiles } = action.payload
            updatedState = {
                ...state, libraries: {
                    ...state.libraries,
                    [source]: {
                        ...state.libraries[source],
                        tiles,
                        source,
                        selectionGrid: tiles,
                        trace:[]
                    }
                }
            }
        }
            break;
        case ACTIONS.ADD_NAV_TRACE: {
            const traceCrumb = action.payload
            const source = state.source
            if (source) {
            updatedState = {
                    ...state, libraries: {
                        ...state.libraries,
                        [source]: {
                            ...state.libraries[source],
                            trace: [...state.libraries[source].trace, traceCrumb]
                        }
                    }
                }
            }
        }
            break;
        case ACTIONS.REMOVE_NAV_TRACE: {
            const traceCrumb = action.payload
            const source = state.source
            if (source) {
                const selectedCrumbIndex = state.libraries[source].trace.findIndex(crumb => crumb.id === traceCrumb.id)
            updatedState = {
                    ...state, libraries: {
                        ...state.libraries,
                        [source]: {
                            ...state.libraries[source],
                            trace: [...state.libraries[source].trace.slice(0, selectedCrumbIndex + 1)]
                        }
                    }
                }
            }
        }
            break;
        case ACTIONS.ADD_TO_LIBRARY: {
            const {
                source,
                tiles,
            } = action.payload

            updatedState = {
                ...state, libraries: {
                    ...state.libraries,
                    [source]: {
                        ...state.libraries[source],
                        selectionGrid: tiles
                    }
                }
            }
        }
            break;
        case ACTIONS.UPDATE_IMAGE_FILTERS:
            updatedState = {
                ...state,
                updatedFilters: action.payload.filters
            }
            break;    
        default:
            updatedState = state;
            break;
    }
    return updatedState
}

export const getParentTile = (navtrace: LibraryTraceCrumb[], library: ThirdPartyLibrary): {
    parentTile: ThirdPartyLibraryTile | undefined,
} => {

    let tiles: ThirdPartyLibraryTile[] | undefined = library.tiles
    let parentTile: ThirdPartyLibraryTile | undefined

    for (let index = 0; index < navtrace.length; index++) {
        const crumbId = navtrace[index].id;
        parentTile = tiles?.find(tile => tile.id === crumbId)
        tiles = parentTile?.tiles;
    }

    return {
        parentTile,
    }
}